import React from "react";
import { motion } from "framer-motion";
import "./AssociationsSection.css";

import aeced from "../../assets/1.avif";
import imc from "../../assets/2.avif";
import eca from "../../assets/3.avif";
import oxford from "../../assets/4.avif";

const AssociationsSection = () => {
  const associations = [
    {
      id: 1,
      logo: aeced,
      title: "AECED Membership",
      text: "NIECCE is a Life Member of AECED, Mumbai — an elite association of top preschool and teacher training institutions across India, dedicated to elevating early childhood education standards.",
    },
    {
      id: 2,
      logo: imc,
      title: "IMC Institutional Member",
      text: "As an Institutional Member of IMC, NIECCE participates in specialized programs promoting the Montessori methodology for teachers and students nationwide.",
    },
    {
      id: 3,
      logo: eca,
      title: "ECA Partnership",
      text: "We are proud Life Members of ECA. Through this partnership, NIECCE and ECA collaborate to build globally recognized ECCE curricula aligned with international standards.",
    },
    {
      id: 4,
      logo: oxford,
      title: "Oxford University Press",
      text: "NIECCE collaborates with Oxford University Press to host certified teacher training workshops and seminars that enhance teaching skills and classroom impact.",
    },
  ];

  return (
    <section className="associations-section" id="associations">
      <motion.h2
        className="section-title"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        Our <span>Associations & Memberships</span>
      </motion.h2>

      <div className="associations-grid">
        {associations.map((assoc) => (
          <motion.div
            key={assoc.id}
            className="association-card"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: assoc.id * 0.1 }}
          >
            <img
              src={assoc.logo}
              alt={assoc.title}
              title={`${assoc.title} at NIECCE`}
              className="assoc-logo"
            />
            <h3>{assoc.title}</h3>
            <p>{assoc.text}</p>
          </motion.div>
        ))}
      </div>

      <motion.div
        className="btn-container"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <a href="/course/admission" className="enquiry-btn">
          Admission Enquiry →
        </a>
      </motion.div>
    </section>
  );
};

export default AssociationsSection;
